import { render, staticRenderFns } from "./partner-profile.vue?vue&type=template&id=54858311&"
import script from "./partner-profile.vue?vue&type=script&lang=js&"
export * from "./partner-profile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports